export default {
  activeLayerId: null,
  layers: new Map(),
  loading: false,
  baseLayer: null,
  basePk: null,
  targetLayer: null,
  targetPk: null,
  geoPopLevels: [],
  statusLayer: {
    newLayer: false,
    applyFilter: false
  },
  newLayer: false,
  layersBase: [],
  layersMenu: [],
  environmentDataMenu: -1
}
